// extracted by mini-css-extract-plugin
module.exports = {"layout":"StandardLayout_layout__cEyMF","backToTop":"StandardLayout_backToTop__CylOu"};